import styled, { css } from 'styled-components';
import { defaultMuiTheme } from '../../../styles/MaterialTheme';
export const CommonBackgroundImageStyles = css `
    position: relative;
    overflow: hidden;
    color: ${(props) => props.theme.colors.icon};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;
export const FEATURED_IMAGE_HEIGHT_IN_PX = 160;
const FeaturedBackgroundImage = styled.div `
    ${CommonBackgroundImageStyles}

    color: ${(props) => props.theme.colors.mutedIcon};
    background-image: ${(props) => (props.imageSrc ? `url(${props.imageSrc})` : 'unset')};
    width: 100%;

    max-height: ${FEATURED_IMAGE_HEIGHT_IN_PX}px;
`;
export const SMALL_BACKGROUND_IMAGE_SIZE_IN_PX = 56;
const SmallBackgroundImage = styled.div `
    ${CommonBackgroundImageStyles}

    background-image: ${(props) => (props.imageSrc ? `url(${props.imageSrc})` : 'unset')};
    height: ${SMALL_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    width: ${SMALL_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    border-radius: 8px;
`;
export const MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX = 90;
export const MOBILE_MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX = 60;
const MediumBackgroundImage = styled.div `
    ${CommonBackgroundImageStyles}

    background-image: ${(props) => (props.imageSrc ? `url(${props.imageSrc})` : 'unset')};
    border-radius: 5px;

    width: ${MOBILE_MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    height: ${MOBILE_MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    ${defaultMuiTheme.breakpoints.up('sm')} {
        width: ${MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;
        height: ${MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    }
`;
export const LARGE_BACKGROUND_IMAGE_SIZE_IN_PX = 124;
export const MOBILE_LARGE_BACKGROUND_IMAGE_SIZE_IN_PX = 64;
const LargeBackgroundImage = styled.div `
    ${CommonBackgroundImageStyles}

    background-image: ${(props) => (props.imageSrc ? `url(${props.imageSrc})` : 'unset')};
    border-radius: 8px;

    width: ${MOBILE_LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    height: ${MOBILE_LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    ${defaultMuiTheme.breakpoints.up('sm')} {
        width: ${LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
        height: ${LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    }
`;
export default {
    Featured: FeaturedBackgroundImage,
    Small: SmallBackgroundImage,
    Medium: MediumBackgroundImage,
    Large: LargeBackgroundImage
};
//# sourceMappingURL=BackgroundImage.js.map